module.exports = __webpack_public_path__ + "static/media/isro_logo.605cbf5a.png";